import DataRequest from '@get-bridge/learn-legacy-shared/dist/core/DataRequest'
import LinksPayload from './LinksPayload'
import { objCamelize } from '@get-bridge/learn-legacy-shared/dist/utils/object';

export default DataRequest({
  schema: LinksPayload,
  url: '/api/learner/sub_account/mobile_app_links',

  parse(normalize, payload) {
    return objCamelize(payload.links);
  },
})



// WEBPACK FOOTER //
// ./packages/bridge-global-nav/src/mobile_app_links/fetchLinks.js